import { TrackerListItemOrigin } from '@ketch-com/windlass/dist/dataSentry/v1/trackers/trackers'
import { useDataSentryTrackersList } from 'api/dataSentry/queries/useDataSentryTrackersList'
import { useMemo } from 'react'
import { MostSeenTrackerItemProps } from '../mostSeen/MostSeenTrackerItem'
import { useState } from 'react'
import {
  AuthorizationStatus as TrackerAuthorizationStatus,
  ControlStatus as TrackerControlStatus,
} from '@ketch-com/windlass/dist/dataSentry/v1/trackers/trackers'

interface UseMostSeenTrackersProps {
  startDate?: string
  endDate?: string
  selectedPropertyCode?: string
}

export function useMostSeenTrackers({ startDate, endDate, selectedPropertyCode }: UseMostSeenTrackersProps) {
  const [trackerAuthorizationStatus, setTrackerAuthorizationStatus] = useState<TrackerAuthorizationStatus>(
    TrackerAuthorizationStatus.AUTHORIZED,
  )

  const [trackerControlStatus, setTrackerControlStatus] = useState<TrackerControlStatus>(
    TrackerControlStatus.UNSPECIFIED,
  )

  const { data: trackersList, isLoading } = useDataSentryTrackersList({
    params: {
      'start-date': startDate,
      'end-date': endDate,
      'property-codes': selectedPropertyCode,
      'authorization-status': trackerAuthorizationStatus,
      'control-status': trackerControlStatus,
    },
  })

  const mostSeenTrackers: MostSeenTrackerItemProps[] = useMemo(() => {
    if (!trackersList?.trackers) return []

    return trackersList.trackers.map(tracker => ({
      name: tracker.name!,
      percentage:
        tracker.urlSeenCount && trackersList.totalUrlSeenCount
          ? `${Math.round((tracker.urlSeenCount / trackersList.totalUrlSeenCount) * 100)}`
          : '0',
      origin: tracker.origin || TrackerListItemOrigin.TRACKER_ORIGIN_UNSPECIFIED,
      systemName: tracker.dataSystem?.name || tracker.dataSystem?.code,
      systemLogo: tracker.dataSystem?.logoUrl,
    }))
  }, [trackersList])

  return {
    trackersList,
    mostSeenTrackers,
    isLoading,
    trackerAuthorizationStatus,
    setTrackerAuthorizationStatus,
    trackerControlStatus,
    setTrackerControlStatus,
  }
}
